import React from 'react';
import {Button, Modal} from "react-bootstrap";
import {DataAPI, MutationAPI, useData, useMutator} from "../../services/API";
import type {UserAdminInfo} from "../../services/API";
import {RouteComponentProps, useParams} from "react-router-dom";
import {ModalUrl, useHandleClose} from "../../commons/ModalHelpers";
import UsersTab from "../UsersTab";
import Notifications from "../Notifications";

const ResetUserPassword = (props: RouteComponentProps) => {

    const { id } = useParams();

    const { isLoading, error, data } = useData(id, 'managed-user', DataAPI.getManagedUser);

    const handleClose = useHandleClose(UsersTab.url);
    const resetPassword = useMutator(MutationAPI.resetUserPassword, {
        afterSuccess: handleClose,
        customMsg: 'Link do ustawienia hasła został wysłany na adres użytkownika'
    });

    const handleReset = () => resetPassword.mutate(id);

    if (isLoading) return null;
    if (error) {
        Notifications.pushNew(error.message, 'danger');
        return null;
    }

    const user: UserAdminInfo = data;
    const hasEmail = !!user.email;

    return (
        <Modal size="sm" show={true} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Ustawienie nowego hasła</Modal.Title>
            </Modal.Header>
            <Modal.Body className="confirm-body">
                <p>Wysłać użytkownikowi <strong>{user.username}</strong> link do ustawienia nowego hasła?</p>
                {hasEmail
                    ? <p>Link pójdzie na adres <strong>{user.email}</strong>. Dotychczasowe hasło działa do chwili, w której użytkownik ustawi nowe.</p>
                    : <p className="text-danger">Ten użytkownik nie ma adresu e-mail, nie ma gdzie wysłać linku. Uzupełnij adres w edycji użytkownika.</p>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>Anuluj</Button>
                <Button variant="primary" disabled={!hasEmail} onClick={handleReset}>Wyślij link</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ResetUserPassword;

ResetUserPassword.url = `/users${ModalUrl}reset/:id`;
ResetUserPassword.buildUrl = user => ResetUserPassword.url.replace(':id', user)
